import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'

class TakeAttendance extends Component {
    classStudentList=()=>{
        let studentData=this.props.studentData;
        let nameList =studentData.map((student,index)=>{
        return <tr style={{padding:"2%"}}><td>{index+1}</td> <td>{student.name}</td> <td><input type="checkbox" key={"roll"+index} className="from-control"/></td></tr>;
        })
        return(
            <table width="100%" border="1" cellPadding="5" >
                <tr><td></td><td>Tick All</td><td><input type="checkbox" onChange={this.checkAllCheckBox} className="from-control"/></td></tr>

                {nameList}                
            </table>
        );
    }

    checkAllCheckBox=()=>{
        
    }
    render() {
        return (
            <div style={{ padding: "10px" }}>

                <form className="was-validated">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                {/* <div className="card-header bg-primary" style={{ color: "white" }}>Add Subject Information</div> */}
                                <div className="card-body">
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label for="fname"><b>Select Class </b></label>
                                            <select class="form-control">
                                                <option>Std 1 </option>
                                                <option>STd 2</option> 
                                                <option>Std 3 </option>
                                                <option>STd 4</option> 
                                                <option>Std 5 </option>
                                                <option>STd 6</option> 
                                            </select>
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label for="fname"><b>Student List</b></label>
                                            {this.classStudentList()}
                                            {/* <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div> */}
                                        </div>
                                        
                                    </div>
                                   

                                    {/* <div class="row">
                                        <div class="col-lg-12 " style={{ textAlign: "end" }}>
                                            <button type="submit" class="btn btn-primary">Submit</button>
                                            <button type="reset" class="btn btn-success">Reset</button>
                                            <button class="btn btn-primary">Back</button>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isUserLoggedIn: state.isAuthenticated,
        studentData: state.studentData
    };
}
const mapDispatchToProps = dispatch => {
    return {
        addStudentToStore: (newStudent) => dispatch({ type: 'AddStudent', studentData: newStudent }),
        deleteStudentToStore: (roll) => dispatch({ type: "DeleteStudent", roll: roll })
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TakeAttendance);
